
if (!customElements.get("dialog-quickview")) {
  class DialogQuickview extends HTMLElement {
    // 代理源
    _refOrigin = {
      variant: null, // 产品变体
    };

    constructor() {
      super();
      // 选择器
      const selectors = {
        closeButton: '.dialog-quickview__close',
        mediaSlide: '.swiper-slide',
        mediaItem: '.dialog-quickview__media',
        form: '.dialog-form',
        variantSelect: '.t4s-product__select',
        variantsJson: '.pr_variants_json',
        optionsJson: '.pr_options_json',
        priceWrapper: '.t4s-product__price-review',
        nowPrice: '.t4s-product__price',
        comparePrice: '.t4s-product__compare_price',
        swatch: '.t4s-swatch',
        swatchOption: '.t4s-swatch .t4s-swatch__option',
        swatchOptionLabel: '.t4s-swatch__title .t4s-swatch__current',
        swatchOptionItem: '.t4s-swatch__list .t4s-swatch__item',
        qtyMinus: '.quantity-selector.is--minus',
        qtyPlus: '.quantity-selector.is--plus',
        qtyInput: '.quantity-input',
        addToCartBtn: 'add-cart-button',
        buyNowBtn: 'buy-now-button',
      };
      this.selectors = selectors;
      // 标记
      const marks = {
        selectedClass: 'is--selected',
        optionDisabledClass: 'is--disabled', // 选项禁止选择
        soldStatus: {
          // 产品可售状态
          available: 'available',
          soldOut: 'sold-out', // 售罄
        },
        activeClass: 'active',
      };
      this.marks = marks;
      // 元素
      const elements = {
        closeButton: this.querySelector(selectors.closeButton),
        mediaSlideList: this.querySelectorAll(selectors.mediaSlide),
        form: this.querySelectorAll(selectors.form),
        variantSelect: this.querySelector(selectors.variantSelect),
        variantsJson: this.querySelector(selectors.variantsJson),
        optionsJson: this.querySelector(selectors.optionsJson),
        priceWrapper: this.querySelector(selectors.priceWrapper),
        nowPrice: this.querySelector(selectors.nowPrice),
        comparePrice: this.querySelector(selectors.comparePrice),
        swatch: this.querySelector(selectors.swatch),
        swatchOptionList: this.querySelectorAll(selectors.swatchOption),
        swatchOptionItemList: this.querySelectorAll(selectors.swatchOptionItem),
        qtyMinus: this.querySelector(selectors.qtyMinus),
        qtyPlus: this.querySelector(selectors.qtyPlus),
        qtyInput: this.querySelector(selectors.qtyInput),
        addToCartBtn: this.querySelector(selectors.addToCartBtn),
        buyNowBtn: this.querySelector(selectors.buyNowBtn),
      };
      this.elements = elements;
      this.variantsJson = JSON.parse(elements.variantsJson.innerHTML);
      this.optionsJson = JSON.parse(elements.optionsJson.innerHTML);

      this.overlay = document.querySelector('.t4s-close-overlay');
      this.html = document.querySelector('html');

      this.initMedia();

      // 代理，数据驱动型
      const proxyHander = {
        get(target, key) {
          return target[key];
        },
        set: (target, property, value) => {
          target[property] = value;
          this.handleRefChanged(this._refOrigin);
          return true;
        },
      };
      const ref = new Proxy(this._refOrigin, proxyHander);
      this.ref = ref;

      this.selectOptons = []; // 已选择的配置

      // 初始化已选择的配置
      for (let option of this.optionsJson) {
        this.selectOptons[option.position - 1] = option.values[0];
      }
      // 初始化代理
      this.ref.variant = this.variantsJson[0];
      this.initEvent();
    }

    connectedCallback() { }

    /** 代理发生变化
     * @param {{variant}} refOrigin 
     */
    handleRefChanged(refOrigin) {
      // 更新变体选择器的值
      this.elements.variantSelect.value = refOrigin.variant.id;
      this.elements.addToCartBtn.setAttribute('data-variant-id', refOrigin.variant.id);
      this.elements.buyNowBtn.setAttribute('data-variant-id', refOrigin.variant.id);
      this.dispatchEvent(new CustomEvent('t4s-quick-view-variant-changed', {
        detail: { variant: refOrigin.variant },
        bubbles: true // 确保事件能够冒泡
      }));
      console.log('Event dispatched from dialog-quickview');
      // 更新已选 Option 项存储数据
      this.selectOptons.length = 0;
      this.selectOptons.push(...refOrigin.variant.options);
      // 更新选 Option 标题视图
      for (let optionEl of this.elements.swatchOptionList) {
        const optionPosition = optionEl.getAttribute('data-option-position');
        const labelEl = optionEl.querySelector(this.selectors.swatchOptionLabel);
        // console.log(optionEl);
        labelEl.innerHTML = this.selectOptons[optionPosition - 1];
      }
      // 更新选 Option 项视图
      for (let optionItemEl of this.elements.swatchOptionItemList) {
        const optionPosition = optionItemEl.getAttribute('data-option-position');
        const value = optionItemEl.getAttribute('data-value');
        const nowIsActived = optionItemEl.classList.contains(this.marks.selectedClass);
        const needIsActived = value == this.selectOptons[optionPosition - 1];
        if (nowIsActived != needIsActived) {
          // 选择项与代理不相同时，才会更新视图
          if (nowIsActived) optionItemEl.classList.remove(this.marks.selectedClass);
          else optionItemEl.classList.add(this.marks.selectedClass);
        }
        // 有时，该选项不能与其他已选项搭配在一起，因为可能没有这样子的变体
        const tempOptions = [...this.selectOptons];
        tempOptions[optionPosition - 1] = value;
        const isExist = this.variantsJson.findIndex((v) => v.options.toString() == tempOptions.toString()) > -1;
        const isDisabled = optionItemEl.classList.contains(this.marks.optionDisabledClass);
        if (isExist == isDisabled) {
          isExist
            ? optionItemEl.classList.remove(this.marks.optionDisabledClass)
            : optionItemEl.classList.add(this.marks.optionDisabledClass);
        }
      }
      // 更新图片轮播位置
      for (const mediaSlide of this.elements.mediaSlideList) {
        const mediaItem = mediaSlide.querySelector(this.selectors.mediaItem);
        if (mediaItem.getAttribute('data-media-id') == this.ref.variant?.featured_media?.id) {
          this.mediaSwiper.slideToLoop(Number(mediaSlide.getAttribute('data-swiper-slide-index')));
        }
      }
      // 更新价格
      const comparePrice = this.ref.variant.compare_at_price; // 可能为 null、0
      const price = this.ref.variant.price;
      this.elements.comparePrice.innerHTML = comparePrice && comparePrice > 0 ? `$${(comparePrice / 100).toFixed(2)}` : '';
      this.elements.nowPrice.innerHTML = `$${(price / 100).toFixed(2)}`;
      this.elements.priceWrapper.setAttribute('data-discounted', comparePrice > price);
      // 更新可售状态
      this.elements.form.forEach((form) => {
        form.setAttribute(
          'data-sold-status',
          refOrigin.variant.available ? this.marks.soldStatus.available : this.marks.soldStatus.soldOut
        );
      });
    }

    updateQuantity(change) {
      let currentQty = parseInt(this.elements.qtyInput.value, 10);
      const maxQty = this.ref.variant.quantity_rule.max ?? Infinity;

      // 更新数量
      currentQty += change;
      if (currentQty < 1) currentQty = 1;
      if (currentQty > maxQty) currentQty = maxQty;

      this.elements.qtyInput.value = currentQty;
      this.elements.addToCartBtn.setAttribute('data-quantity', currentQty);
      this.elements.buyNowBtn.setAttribute('data-quantity', currentQty);
    }

    initMedia() {
      this.mediaThumbSwiper = new Swiper(
        this.querySelector(`.dialog-quickview__media-thumb-container`),
        {
          loop: true,
          spaceBetween: 11,
          centeredSlides: false,
          slidesPerView: 5,
          observer: true,
          resizeObserver: true,
          observeParents: true,
          watchSlidesVisibility: true,
          breakpoints: {},
          on: {
            init: function (swiper) {
              this.update();
            },
          },
        }
      );

      this.mediaSwiper = new Swiper(this.querySelector(`.dialog-quickview__media-container`), {
        loop: true,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        observer: true,
        resizeObserver: true,
        observeParents: true,
        thumbs: {
          swiper: this.mediaThumbSwiper,
        },
        breakpoints: {},
        navigation: {
          nextEl: this.querySelector('.dialog-quickview__media-outer .swiper-btn-next'),
          prevEl: this.querySelector('.dialog-quickview__media-outer .swiper-btn-prev'),
        },
        on: {
          init: function (swiper) {
            this.update();
          },
        },
      });
    }

    initEvent() {
      this.elements.variantSelect.addEventListener('change', (e) => {
        const variantId = this.elements.variantSelect.value;
        const selectedVariant = this.variantsJson.find((v, i, obj) => v.id == variantId);
        this.ref.variant = selectedVariant;
      });
      // 减少数量
      this.elements.qtyMinus.addEventListener('click', () => {
        this.updateQuantity(-1);
      });
      // 增加数量
      this.elements.qtyPlus.addEventListener('click', () => {
        this.updateQuantity(1);
      });
      this.elements.swatch.addEventListener('click', (e) => {
        // 判断点击的元素是否为span，如果是则查找其父元素
        const swatchItem = e.target.matches(this.selectors.swatchOptionItem)
          ? e.target
          : e.target.closest(this.selectors.swatchOptionItem);

        if (swatchItem) {
          // 点击了选择项
          const currentEl = swatchItem;
          const isActived = currentEl.classList.contains(this.marks.selectedClass);
          if (isActived) return;
          currentEl.classList.add(this.marks.selectedClass); // 将选中的元素添加 selectedClass
          const optionPosition = currentEl.getAttribute('data-option-position');
          const optionValue = currentEl.getAttribute('data-value');
          this.selectOptons[optionPosition - 1] = optionValue;
          // 根据所有已选项，找出对应的变体
          const find = this.variantsJson.find((v, i) => v.options.toString() === this.selectOptons.toString());
          if (find) this.ref.variant = find;
          // console.log(optionValue);
        }
      });

      this.elements.closeButton.addEventListener('click', (e) => {
        this.classList.remove('dialog-quickview--opened');
        this.overlay.classList.remove('is--visible');
        this.html.classList.remove('t4s-lock-scroll');
      });
    }
  }

  customElements.define("dialog-quickview", DialogQuickview);
}

if (!customElements.get("btn-show-quickview")) {
  /**
   * 触发 Quickview Dialog 的按钮
   * @param {String} data-dialog-id
   */
  class ShowQuickviewButton extends HTMLElement {
    constructor() {
      super();
      this.overlay = document.querySelector('.t4s-close-overlay');
      this.htmlEl = document.querySelector('html');

      this.initEvents();
    }

    initEvents() {
      this.overlay.addEventListener('click', (e) => {
        const dialogEl = document.querySelector('.dialog-quickview--opened');
        dialogEl?.classList.remove('dialog-quickview--opened');
        this.overlay.classList.remove('is--visible');
        this.htmlEl.classList.remove('t4s-lock-scroll');
      });
      this.addEventListener('click', function (e) {
        const id = this.getAttribute('data-dialog-id');
        const dialogEl = document.getElementById(`dialog-quickview__${id}`);
        dialogEl.classList.add('dialog-quickview--opened');
        this.htmlEl.classList.add('t4s-lock-scroll');
        this.overlay.classList.add('is--visible');
        $(window).trigger('resize');
      });
    }

    connectedCallback() { }
  }

  customElements.define("btn-show-quickview", ShowQuickviewButton);
}

/**
 * 解决 Dialog 与 侧边 Cart 冲突
 */
(function () {
  const dialogEl = document.querySelector('.dialog-quickview');
  if (!dialogEl) return;
  // 目标元素
  const target = document.querySelector('html');
  // 创建一个MutationObserver实例
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // 监听到 class 属性发生变化，执行相应的操作
        if (target.classList.contains('is--opend-drawer')) {
          const dialogEls = document.querySelectorAll('.dialog-quickview');
          for (let el of dialogEls) el.classList.remove('dialog-quickview--opened'); /// 关闭 Dialog
        }
      }
    });
  });
  // 配置观察选项
  const config = { attributes: true };
  // 传入目标节点和观察选项开始观察
  observer.observe(target, config);
})();